import { FaFacebook, FaInstagram, FaXTwitter, FaYoutube } from 'react-icons/fa6';

export const TEAM_NAME = 'Hyderabad Toofans';

export const ORGANISATION = {
  name: 'Resolute Sports Private Limited',
  website: 'https://resolutecorp.in/',
  addressLines: ['10th Floor, Kataria Arcade, Off SG Highway,', 'Post: Makarba, Ahmedabad - 380051, Gujarat, India'],
  email: 'contact@resolutesports.in',
  phone: '+91 79 4992 0484',
  tagline: 'Official team in the Hockey India League',
  hashtags: '#DilSeToofan | #HyderabadToofans',
};

export const NAV_LINKS = [
  { name: 'About Us', to: '/About' },
  { name: 'Toofani Squad', to: '/Squad' },
  { name: 'Fixtures & Results', to: '/Fixtures&Results' },
  { name: 'Gallery', to: '/Gallery' },
  { name: 'Sponsors', to: '/Sponsors' },
];

export const SOCIAL_LINKS = [
  { label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61566170158398', Icon: FaFacebook },
  { label: 'X (Twitter)', href: 'https://x.com/HToofans', Icon: FaXTwitter },
  { label: 'Instagram', href: 'https://www.instagram.com/hyderabadtoofans/', Icon: FaInstagram },
  { label: 'YouTube', href: 'https://www.youtube.com/@HyderabadToofans', Icon: FaYoutube },
];

const ADD_EVENT_ID = 'p8bh328lnf3p';
export const CALENDAR_PROVIDERS = [
  { label: 'Google', provider: 'google', color: '#4285F4', icon: 'calendar' },
  { label: 'Outlook.com', provider: 'outlookcom', color: '#0072C6', icon: 'mail' },
  { label: 'Microsoft 365', provider: 'office365', color: '#F25022', icon: 'building' },
  { label: 'Apple', provider: 'apple', color: '#000000', icon: 'apple' },
  { label: 'Yahoo', provider: 'yahoo', color: '#720E9E', icon: 'calendar' },
].map((option) => ({ ...option, href: `https://www.addevent.com/event/${ADD_EVENT_ID}+${option.provider}` }));
